var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gl-avatar-link',{staticClass:"gl-ml-3",attrs:{"href":_vm.owner.webPath,"title":_vm.owner.name}},[_c('gl-avatar',{attrs:{"size":32,"src":_vm.owner.avatarUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }